import React, { forwardRef } from 'react'
import { createUseStyles } from 'react-jss'
import cn from 'classnames'
import RichText from '../RichText'
import theme from '../../style/theme'
import { sliceMarginStyles, span } from '../../style/span'
import { vw } from '../../style/vw'

const TwoColumnRichText = forwardRef(({ className, slice, tag = 'div', serializers }, ref) => {
  const { leftText, rightText } = slice
  const classes = useStyles()

  return (
    <section className={cn(classes.content, className)} ref={ref}>
      <RichText content={leftText?.text} tag={tag} serializers={serializers} className={classes.left} />
      <RichText content={rightText?.text} tag={tag} serializers={serializers} className={classes.right} />
    </section>
  )
})

const useStyles = createUseStyles({
  content: {
    extend: [sliceMarginStyles],
    padding: [0, span(1)],
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      padding: [0, span(1, 'md')],
      flexDirection: 'row'
    }
  },
  left: {
    marginBottom: vw(20),
    [theme.breakpoints.up('md')]: {
      marginBottom: 0,
      width: span(8, 'md')
    }
  },
  right: {
    [theme.breakpoints.up('md')]: {
      marginLeft: span(4, 'md'),
      width: span(8, 'md')
    }
  }
}, { name: 'TwoColumnRichText' })

export default TwoColumnRichText
